import * as React from "react";
import { CourseAward } from "@kalabo/golfsavers-common";
import { Button, Text } from "@uikit";
import AwardIcon from "../../../images/award.svg";

interface IProps {
  awards?: CourseAward[];
}

const CourseAwards = ({ awards }: IProps) => {
  const [visible, setVisible] = React.useState(3);

  if (!awards || awards.length === 0) return null;
  return (
    <>
      {awards && awards.length > 0 && (
        <div>
          <Text
            element="h3"
            size={17}
            leading={1.3}
            weight="semibold"
            className="mb-[20px]"
            color="black90"
          >
            Notable Awards
          </Text>
          <div className="flex flex-col gap-6 mb-6">
            {awards &&
              awards
                .slice(0, visible)
                .map((award: CourseAward, aIdx: any) => (
                  <Award key={aIdx} {...award} />
                ))}
          </div>

          {visible < awards.length && (
            <Button
              text={`Show all awards`}
              color="grey7"
              invert
              size="small"
              onClick={() => {
                setVisible((prevValue) => prevValue + 5);
              }}
            />
          )}
        </div>
      )}
    </>
  );
};

const Award = ({ name, year, awarded_by }: CourseAward) => {
  return (
    <div className="flex">
      <AwardIcon className="mr-2" />
      <div className="flex flex-col">
        <Text size={15} leading={1.5} color="black90" className="mb-1">
          {name}
        </Text>
        <div className="flex gap-2">
          <Text size={13} color="black60">
            {awarded_by} ({year})
          </Text>
        </div>
      </div>
    </div>
  );
};
export default CourseAwards;
